import { Injectable } from '@angular/core';

import { GenericServiceValue, PersonalDoctorValue, PharmacologicalTreatmentValue, PrescriptionFormValue } from '@lib/core/models/prescription.interface';

@Injectable({
  providedIn: 'root',
})
export class PrescriptionsStorageService {
  private readonly storageKey = 'prescription-drafts';

  saveDrafts(drafts: PrescriptionFormValue<PharmacologicalTreatmentValue | GenericServiceValue | PersonalDoctorValue>[]): void {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(drafts));
    } catch (error) {
      console.error('Error saving drafts to localStorage:', error);
    }
  }

  loadDrafts(): PrescriptionFormValue<PharmacologicalTreatmentValue | GenericServiceValue | PersonalDoctorValue>[] {
    try {
      const saved = localStorage.getItem(this.storageKey);
      return saved ? JSON.parse(saved) : [];
    } catch (error) {
      console.error('Error loading drafts from localStorage:', error);
      return [];
    }
  }

  clearDrafts(): void {
    try {
      localStorage.removeItem(this.storageKey);
    } catch (error) {
      console.error('Error clearing drafts from localStorage:', error);
    }
  }
}
